import { render } from "./Epay.vue?vue&type=template&id=7da2c477&ts=true"
import script from "./Epay.vue?vue&type=script&lang=ts"
export * from "./Epay.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__